interface GuideScreenProps {
  onStart: () => void;
}

// 게임 소개: 태그 → 게임명 + 1~2줄 설명 + 일러스트 + 게임 시작하기
// 두뇌풀기 자체에 대한 설명은 이전 안내 페이지에서 끝내고, 이 화면은 '이번 게임이 무엇이고 어떻게 하는가'만 다룬다.
export default function GuideScreen({ onStart }: GuideScreenProps) {
  return (
    <div className="relative flex flex-col h-full bg-white px-6 animate-fade-in-up overflow-hidden">
      {/* 배경 장식: 일러스트 뒤 좌측에 은은한 라이트 */}
      <div className="pointer-events-none absolute -left-16 top-[44%] w-44 h-44 rounded-full bg-primary-100/70 blur-xl" />

      {/* Visual Anchor: 태그 → 게임명 → 설명 → 일러스트를 하나의 그룹으로 묶는다 */}
      <div className="relative flex-1 min-h-0 overflow-y-auto flex flex-col">
        <div className="m-auto w-full flex flex-col items-center">
          <div className="relative flex flex-col items-center text-center">
            {/* 타이틀 오른쪽 옅은 보라 원형 BG (참고 이미지 원본 사용) */}
            <img
              src="https://storage.helloreaddy.io/project_files/a1e21e58-82d2-4e64-8a34-d104a4996fee/e048128c-bcac-444c-9c78-bd1eba0334e7_compressed_Ellipse-2883.webp"
              alt=""
              aria-hidden="true"
              className="pointer-events-none select-none absolute -top-6 -right-12 w-16 h-16 object-contain"
            />
            <span className="relative inline-flex items-center h-8 px-4 rounded-full bg-primary-50 text-primary-600 text-[14px] font-bold whitespace-nowrap">
              #단기기억
            </span>

            <h1 className="relative text-[28px] font-bold text-foreground-950 leading-tight tracking-tight mt-4 text-center">
              순서 기억하기
            </h1>
          </div>

          <p className="text-[15px] leading-relaxed text-foreground-600 mt-3 text-center">
            불이 켜지는 위치와 순서를 기억한 뒤
            <br />
            같은 순서대로 눌러주세요.
          </p>

          <div className="mt-8 w-[340px] h-[430px] max-w-full">
            <img
              src="https://storage.helloreaddy.io/project_files/a1e21e58-82d2-4e64-8a34-d104a4996fee/8137af78-a05a-4799-ba9b-81fd6bed3f02_compressed_-.webp"
              alt="순서 기억하기 게임 일러스트"
              title="순서 기억하기 게임 일러스트"
              className="w-full h-full object-contain"
            />
          </div>
        </div>
      </div>

      <div className="relative shrink-0 pt-4 pb-[calc(20px+env(safe-area-inset-bottom))]">
        <button
          onClick={onStart}
          className="w-full h-14 rounded-xl sh-cta text-white font-semibold text-base whitespace-nowrap
            active:scale-[0.99] transition-transform duration-150 cursor-pointer"
        >
          게임 시작하기
        </button>
      </div>
    </div>
  );
}